import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import signupImage from "../images/signup.png";
  import axios from "axios";
  import { API_URL } from "../components/Constant";
  import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
  import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
  import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
  import OTPInput from "../components/Otp";
  import avr1 from "../images/avr1.png";
  import avr2 from "../images/avr2.png";
  import avr3 from "../images/avr3.png";
  import avr4 from "../images/avr4.png";
  import avr5 from "../images/avr5.png";
  import avr6 from "../images/avr6.png";
  import avr7 from "../images/avr7.png";
  import avr8 from "../images/avr8.png";
  import avr9 from "../images/avr9.png";
  import avr10 from "../images/avr10.png";
  import avr11 from "../images/avr11.png";
  import avr12 from "../images/avr12.png";
  import { Visibility, VisibilityOff } from "@mui/icons-material";
  
  import { useSearchParams } from "react-router-dom";
  import Colors from "../components/Colors";
  import TextfieldComponent from "../components/TextfeildComponent";
  
  function Profile() {
    const passwordMap = {
      lion: avr1,
      tiger: avr2,
      squirrel: avr3,
      pig: avr4,
      rabbit: avr5,
      cat: avr6,
      blueberry: avr7,
      mango: avr8,
      apple: avr9,
      orenge: avr10,
      strawberry: avr11,
      grape: avr12,
    };
  
    const [searchParams] = useSearchParams();
    const referralId = searchParams.get("referral");
  
    console.log("Referral ID:", referralId);
  
    const [name, setName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [countryCode, setCountryCode] = useState("+91");
    const [nameError, setNameError] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [countryCodeError, setCountryCodeError] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [signupError, setSignupError] = useState("");
    const [isOtp, setIsOtp] = useState(false);
    const [isOtpSuccess, setIsOtpSuccess] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);
    const [selectedAnimal, setSelectedAnimal] = useState("");
    const [selectedFruit, setSelectedFruit] = useState("");
    const [passwordUpdte, setPasswordUpdate] = useState(false);
     const [showPasswordcon, setShowPasswordcon] = useState(false);
     const [passwordcon, setPasswordcon] = useState("");
     const [passwordCurrent, setPasswordCurrent] = useState("");
     const [passwordCurrentError, setPasswordCurrentError] = useState("");
     const [passwordConError, setPasswordConError] = useState("");
     const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
     const [isVerifyDisabled, setIsVerifyDisabled] = useState(false);
     const [updateError, setUpdateError] = useState("");
  
     
    
  
    // Handle change for name field
    const handleNameChange = (e) => {
      setName(e.target.value);
      setNameError("");
      setSignupError("");
    };
  
    const handleCountryCodeChange = (e) => {
      let newValue = e.target.value;
      if (/^\+?\d*$/.test(newValue)) {
        if (newValue.length <= 4) {
          setCountryCode(newValue);
        }
      }
      setCountryCodeError("");
      setPhoneNumberError("");
      setSignupError("");
    };
  
    const handlePhoneChange = (e) => {
      const newValue = e.target.value;
      if (/^\d*$/.test(newValue) && newValue.length <= 10) {
        setPhoneNumber(newValue);
      }
      setPhoneNumberError("");
      setCountryCodeError("");
      setSignupError("");
    };
  
    const handlePasswordChange = (event) => {
      setPassword(event.target.value);
      setPasswordError("");
      setPasswordCurrentError("");
      setPasswordConError("")
      setUpdateError("");
    };
  
    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    const handlePasswordCurrentChange = (event) => {
        setPasswordCurrent(event.target.value);
        setPasswordError("");
        setPasswordCurrentError("");
        setPasswordConError("")
        setUpdateError("");
      };
    
      const togglePasswordCurrentVisibility = () => {
        setShowPasswordCurrent((prev) => !prev);
      };
  
    const sanitizeName = (name) => name.trim();
  
    
    const handleUpdatePassword = async () => {      
      setPasswordUpdate(true); // Re-enable the button after request completes
    };
  
    const handleSignInButtonClick = () => {
      window.location.href = "/player-signin";
    };
  
    useEffect(() => {
      console.log(isOtpSuccess);
  
      if (isOtpSuccess) {
        const insertPlayerData = async () => {
          const country = countryCode.replace(/^\+/, "");
  
          try {
            const response = await axios.post(
              `${API_URL}/insert_player_details`,
              {
                name: name,
                countryCode: country,
                phone: phoneNumber,
                password: password,
              },
            );
  
            console.log(response.data);
  
            if (response.data.success) {
              setIsOtp(false);
              localStorage.setItem("PlayerId", response.data.player_id);
              localStorage.setItem("PlayerTocken", response.data.tocken);
              window.location.href = "/player-landing";
            }
          } catch (error) {
            console.error("Something went wrong:", error);
          }
        };
  
        // Call the function
        insertPlayerData();
      }
    }, [isOtpSuccess]);


    useEffect(() => {
        if (localStorage.getItem("PlayerTocken")) {
          const fetchSpData = async () => {
            try {
              const response = await axios.post(
                `${API_URL}/select_player_details_with_tocken`,
                {
                  PlayerTocken: localStorage.getItem("PlayerTocken"),
                },
              );
             setName(response.data.result.name)
             setCountryCode(response.data.result.country_code)
             setPhoneNumber(response.data.result.phone)
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };
          fetchSpData();
         
        }
      }, [localStorage.getItem("PlayerTocken")]);

      const handlePasswordChangecon = (event) => {
        setPasswordcon(event.target.value);
        setPasswordError("");
        setPasswordCurrentError("");
        setPasswordConError("")
        setUpdateError("");
      };
    
      const togglePasswordVisibilitycon = () => {
        setShowPasswordcon(!showPasswordcon);
      };

      const handleRresetPassword = async () => {      
        const trimmedPassword = passwordCurrent.trim();
        const trimmedPasswordNew = passwordcon.trim();
        if (passwordCurrent.trim() === "") {
          setPasswordCurrentError("Please enter your current password");
        } else if (password.trim() === "") {
          setPasswordError("Please enter your new password");
        } else if (passwordcon.trim() === "") {
          setPasswordConError("Please enter your confirm");
        } else if (passwordCurrent === password) {
            setUpdateError("Your current password and new password cannot be the same.");
        } else if (passwordcon !== password) {
            setUpdateError("New password and confirm password do not match.");
          }
         else {
            setIsVerifyDisabled(true);
          try {
            const response = await axios.post(`${API_URL}/update_player_password`, {
              passwordNew: trimmedPasswordNew,
              password: trimmedPassword,
              PlayerTocken: localStorage.getItem("PlayerTocken"),
            });
            console.log("sign in", response.data);
            setUpdateError(response.data.error);
            if (response.data.success === true) {
             setPasswordUpdate(false)
             setIsVerifyDisabled(false);
            }
            else{
                setIsVerifyDisabled(false);
            }}
            catch (error) {
            console.error("something went wrong", error);
          }
        }
      };
  
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: Colors.Tidesbg,
          width: "100%",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            background: Colors.signupboxbg,
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "40%", xs: "90%" },
            maxHeight: { md: "62%", xs: "60%" },
            borderRadius: "28px",
            borderColor: "#ee8e4c !important",
            border: "2px solid",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: "100%",
              gap: "32px",
              justifyContent: "center",
              alignItems: "center",
              maxWidth: { md: "95%", xs: "90%" },
              maxHeight: "90%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: { md: "80%", xs: "100%" },
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "fit-content",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Roboto",
                    fontSize: "28px",
                    fontWeight: 600,
                    color: "#fff",
                  }}
                >
                  My Profile!
                </Typography>
  
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "fit-content",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap: "4px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                      color: "#fff",
                    }}
                  >
                    Nick name:
                  </Typography>
                  <TextfieldComponent value={name}  InputProps={{ readOnly: true }}
  sx={{ cursor: 'none' }}
                  />
  
                  {nameError && (
                    <Typography
                      sx={{
                        color: "red",
                        fontFamily: "Roboto",
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 400,
                      }}
                    >
                      {nameError}
                    </Typography>
                  )}
                </Box>
  
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    height: "fit-content",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  <Box sx={{ width: { md: "20%", xs: "35%" } }}>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 400,
                        color: "#fff",
                      }}
                    >
                      Country code:
                    </Typography>
                    <TextfieldComponent
                      value={countryCode}
                      InputProps={{ readOnly: true }}
                      sx={{ cursor: 'none' }}
                    />
                  </Box>
                  <Box sx={{ width: { md: "80%", xs: "65%" } }}>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 400,
                        color: "#fff",
                      }}
                    >
                      Phone number:
                    </Typography>
                    <TextfieldComponent
                      value={phoneNumber}
                      InputProps={{ readOnly: true }}
  sx={{ cursor: 'none' }}
                    />
                  </Box>
                </Box>
                {countryCodeError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {countryCodeError}
                  </Typography>
                )}
                {phoneNumberError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {phoneNumberError}
                  </Typography>
                )}
  
            
               
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "8px",
                    marginTop: { md: "16px", xs: "16px" },
                  }}
                >
                  <Button
                    onClick={handleUpdatePassword}
                    disabled={isRegistering}
                    sx={{
                      background: Colors.button2,
                      color: Colors.button2font,
                      height: { md: "36px", xs: "32px" },
                      width: "100%",
                      border: "1px solid",
                      borderColor: Colors.button2Border,
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontSize: "12px",
                      transition: "background 0.3s, transform 0.3s",
                      "&:hover": {
                        background: Colors.button2,
                        transform: "scaleY(1.05)",
                      },
                      "&:active": {
                        background: Colors.button2,
                      },
                    }}
                  >
                   Change My Password
                  </Button>
                  {signupError && (
                    <Typography
                      sx={{
                        color: "red",
                        fontFamily: "Roboto",
                        fontSize: { xs: "12px", md: "14px" },
                        fontWeight: 400,
                      }}
                    >
                      {signupError}
                    </Typography>
                  )}
                </Box>
  
               
              </Box>
            </Box>
          </Box>
        </Box>
  
        {passwordUpdte && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "1000",
            }}
          >
           
             
  
              <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          background: Colors.signupboxbg,
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { md: "40%", xs: "90%" },
          maxHeight: { md: "75%", xs: "70%" },
          borderRadius: "28px",
          borderColor: Colors.signupBorder,
          border: "2px solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
           // gap: "32px",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: { md: "95%", xs: "85%" },
            maxHeight: "90%",
          }}
        >
             <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  onClick={() => {
                    setPasswordUpdate(false); 
                  }}
                  sx={{
                    color: "#fff",
                    "&:hover": {
                      color: "#ee8e4c"
                    },
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
          <Box
            sx={{
              display: "flex", 
              flexDirection: "column",
              width: { md: "80%", xs: "100%" },
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
             // gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "28px",
                  fontWeight: 600,
                  color: "#fff",
                }}
              >
                Reset Password
              </Typography>

              <Box sx={{
                display: 'flex', flexDirection: 'column', width: '100%', height: 'fit-content',
                justifyContent: 'center', alignItems: 'flex-start', gap: '4px'
              }}>
                 <Typography sx={{ fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' },
                 fontWeight: 400,color:'#fff', }}>Enter your current password:</Typography>
                <TextfieldComponent
                    type={showPasswordCurrent ? "text" : "password"}
                    value={passwordCurrent}
                    onChange={handlePasswordCurrentChange}                  
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: '10px' }}>
                        <IconButton onClick={togglePasswordCurrentVisibility} edge="end">
                          {!showPasswordCurrent ? (
                            <VisibilityOff sx={{ color: '#ee8e4c' }} />
                          ) : (
                            <Visibility sx={{ color: '#ee8e4c' }} />
                          )}
                        </IconButton>
                      </InputAdornment>

                ),       
      }}
     
    />
                

                {passwordCurrentError && <Typography sx={{ color: 'red', fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }}>
                  {passwordCurrentError}</Typography>}
              </Box> 

             <Box sx={{
                display: 'flex', flexDirection: 'column', width: '100%', height: 'fit-content',
                justifyContent: 'center', alignItems: 'flex-start', gap: '4px'
              }}>
                 <Typography sx={{ fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' },
                 fontWeight: 400,color:'#fff', }}>Enter your new password:</Typography>
                <TextfieldComponent
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}                  
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: '10px' }}>
                        <IconButton onClick={togglePasswordVisibility} edge="end">
                          {!showPassword ? (
                            <VisibilityOff sx={{ color: '#ee8e4c' }} />
                          ) : (
                            <Visibility sx={{ color: '#ee8e4c' }} />
                          )}
                        </IconButton>
                      </InputAdornment>

                ),       
      }}
     
    />
                

                {passwordError && <Typography sx={{ color: 'red', fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }}>
                  {passwordError}</Typography>}
              </Box> 
              <Box sx={{
                display: 'flex', flexDirection: 'column', width: '100%', height: 'fit-content',
                justifyContent: 'center', alignItems: 'flex-start', gap: '4px'
              }}>
                 <Typography sx={{ fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' },
                 fontWeight: 400,color:'#fff', }}>Confirm password:</Typography>
                <TextfieldComponent
                    type={showPasswordcon ? "text" : "password"}
                    value={passwordcon}
                    onChange={handlePasswordChangecon}                  
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" sx={{ marginRight: '10px' }}>
                        <IconButton onClick={togglePasswordVisibilitycon} edge="end">
                          {!showPasswordcon ? (
                            <VisibilityOff sx={{ color: '#ee8e4c' }} />
                          ) : (
                            <Visibility sx={{ color: '#ee8e4c' }} />
                          )}
                        </IconButton>
                      </InputAdornment>

                ),       
      }}
     
    />
                

                {passwordConError && <Typography sx={{ color: 'red', fontFamily: 'Roboto', fontSize: { xs: '12px', md: '14px' }, fontWeight: 400 }}>
                  {passwordConError}</Typography>}
              </Box>  


              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  height: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px",
                  marginTop: { md: "16px", xs: "16px" },
                }}
              >
                <Button
                disabled={isVerifyDisabled}
                 onClick={handleRresetPassword}
                  sx={{
                    background: Colors.button2,
                    color: Colors.button2font,
                    height: { md: "36px", xs: "32px" },
                    width: "100%",
                    border: "1px solid",
                    borderColor: Colors.button2Border,
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "12px",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background: Colors.button2,
                      transform: "scaleY(1.05)",
                    },
                    "&:active": {
                      background: Colors.button2,
                    },
                  }}
                >
                  Change Password
                </Button>

             {updateError && (
                  <Typography
                    sx={{
                      color: "red",
                      fontFamily: "Roboto",
                      fontSize: { xs: "12px", md: "14px" },
                      fontWeight: 400,
                    }}
                  >
                    {updateError}
                  </Typography>
                )} 
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
          </Box>
        )}
      </Box>
    );
  }
  
  export default Profile;
  